import useDocumentGenerationHandler, {
    DocumentGenerationContextData,
    DocumentGenerationStatusData,
    DocumentGenerationType,
} from '../../document/useDocumentGenerationHandler'
import * as UUID from 'uuid'
import { AxiosResponse } from 'axios'
import { QueueCallbacks } from '../../useQueueStateHandler'
import { InvoiceParams } from './useInvoiceListMenuItems'
import { PersistInvoiceDto } from './usePersistInvoice'

export type SubmitInvoiceDocumentGeneration = (
    data: PersistInvoiceDto,
    callbacks?: QueueCallbacks<InvoiceParams, DocumentGenerationStatusData, DocumentGenerationContextData>,
) => void

export default function useSubmitInvoiceDocumentGeneration(
    generationType: DocumentGenerationType,
    hookCallbacks?: QueueCallbacks<InvoiceParams, DocumentGenerationStatusData, DocumentGenerationContextData>,
): SubmitInvoiceDocumentGeneration {
    const handler = useDocumentGenerationHandler<InvoiceParams, DocumentGenerationStatusData>()

    return (
        data: PersistInvoiceDto,
        dispatchCallbacks?: QueueCallbacks<InvoiceParams, DocumentGenerationStatusData, DocumentGenerationContextData>,
    ) => {
        ;(data.children || [{ ...data }]).forEach(invoice => {
            handler.dispatch(UUID.v4(), {
                abortController: undefined,
                method: undefined,
                // The document generate endpoint produces only a UUID that represents the Azure SB message ID.
                mapDispatchResponse: (response: AxiosResponse<string>) => ({
                    messageId: response.data,
                    driveItem: undefined,
                }),
                generationType,
                url: '/document/generate',
                data: { invoiceId: invoice.invoiceId, generationType } as InvoiceParams,
                title: invoice.invoiceNumber,
                callbacks: {
                    ...(hookCallbacks || {}),
                    ...(dispatchCallbacks || {}),
                },
            })
        })
    }
}
